<template>
  <div class="read-more-container">
    <div v-if="!shouldShowReadMore">
      <div v-html="text"></div>
    </div>
    <div v-else-if="!isExpanded" class="truncated-content">
      <div v-html="truncatedText"></div>
      <button
        @click="toggleExpanded"
        class="read-more-button"
        type="button"
      >
        {{ clamp }}
      </button>
    </div>
    <div v-else class="expanded-content">
      <div v-html="text"></div>
      <button
        @click="toggleExpanded"
        class="read-more-button"
        type="button"
      >
        {{ less }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  truncated: {
    type: Boolean,
    default: true,
  },
  collapsedTextClass: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    required: true,
  },
  clamp: {
    type: String,
    default: 'Read More',
  },
  length: {
    type: Number,
    default: 280,
  },
  less: {
    type: String,
    default: 'Show Less',
  },
  type: {
    type: String,
    default: 'text',
  },
  actionClass: {
    type: String,
    default: '',
  },
});

const isExpanded = ref(false);

const truncatedText = computed(() => {
  if (!props.text || props.text.length <= props.length) {
    return props.text;
  }
  return `${props.text.substring(0, props.length)}...`;
});

const shouldShowReadMore = computed(() => props.text && props.text.length > props.length);

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};
</script>

<style lang="scss">
.read-more-container {
  .read-more-button {
    border: 0;
    background: transparent;
    padding: 0;
    text-decoration: underline;
    color: var(--sapphire-500);
    cursor: pointer;
    margin-left: 4px;

    &:hover {
      opacity: 0.8;
    }
  }

  .truncated-content,
  .expanded-content {
    display: inline;
  }
}
</style>
